import { CSSProperties } from "react";
import { CardShift, Direction } from "../interface/game";
import { Card } from "./Card";
import './Pile.css'
import { PileData, pileCardMargins } from "./Pile";

export interface PileProperties {
    cards: PileData;
    direction: Direction;
    width: number;
    height: number;
    top: number;
    left: number;
}

export function DraggingPile({cards, direction, width, height, top, left}: PileProperties) {
    const marginSpec = pileCardMargins[direction]; 

    const pileStyle: CSSProperties = {
        width: width,
        height: height,
        top: top,
        left: left
    };
    return <div className={`card-pile card-pile-${direction} dragging-pile`} style={pileStyle}>
        {cards.map(function cardMapper(this: {offset: number}, cardData, index) {
            const cardStyle: CSSProperties = {
                [marginSpec[0]]: `${this.offset}%`
            }
            this.offset += marginSpec[cardData.shift+1] as number;
            return <Card 
                className={`card ${cardData.shift === CardShift.OPEN ? 'open' : ''}`}
                {...cardData.card}
                cardId={cardData.id}
                draggable={false}
                onCardDrag={() => {}}
                key={cardData.id}
                style={cardStyle} />
        }, {offset: 0})}
    </div>
}